export const INDUSTRIES = {
  "auto-detailing": {
    slug: "auto-detailing",
    name: "Auto Detailing",
    title: "Websites for auto detailing businesses.",
    seoTitle: "Auto Detailing Website Design — Built & Managed | WebJesters",
    description:
      "Mobile-first websites for auto detailers: before-and-after photos, click-to-call, quote forms and instant lead alerts. $499 build + $79/mo.",
    intro:
      "Detailing customers decide on their phone, usually after seeing your work. Your site needs to prove quality fast, make calling or texting effortless, and capture the quote request before they scroll on. That's what we build — then we host it, maintain it, and keep it working.",
    needs: [
      ["Proof up front", "Before-and-after photos of your actual work, placed where visitors look first — not buried in a gallery page."],
      ["Click-to-call and tap-to-text", "Detailing is a phone-first business. Every page keeps a call or text action within thumb reach on mobile."],
      ["Quote requests that reach you instantly", "A short form for vehicle, service, and location, with lead alerts sent straight to your email."],
      ["Mobile and fleet positioning", "If you come to the customer or serve fleets, the site says so clearly, with service area and scheduling expectations set early."],
    ],
    example: {
      name: "Cab Reset AZ",
      label: "Live · Owner's business",
      category: "Mobile auto detailing · Phoenix metro",
      url: process.env.REACT_APP_CLIENT_CABRESETAZ_URL || "https://cabresetaz.com/",
      domain: "cabresetaz.com",
      desktop: "/portfolio/interior-reset-desktop.jpg",
      mobile: "/portfolio/interior-reset-mobile.jpg",
      summary:
        "Mobile auto detailing website with lead capture, mobile-first design, and local service positioning — built, hosted, and managed by us.",
      accent: "#facc15",
    },
    faqs: [
      {
        q: "How much does an auto detailing website cost?",
        a: "$499 one-time to build, plus $79/month to host, maintain, and support it. A $99 deposit reserves your build slot. Month-to-month, cancel anytime.",
      },
      {
        q: "Can the site show my before-and-after work?",
        a: "Yes. Photos of your real work are the centerpiece, and you can add or swap photos yourself any time through the Command Center portal.",
      },
      {
        q: "Can you also keep my Google Business Profile and socials active?",
        a: "Yes. A one-time Google Business Profile setup or cleanup is $299 per location with no subscription. If you want it kept active, our standalone Local Visibility service is $149 onboarding plus $299/month for four content pieces a month posted to your Google Business Profile and Facebook or Instagram, prepared from the photos and clips you send us with captions, simple branding, and light edits where needed.",
      },
    ],
  },
  "scrap-metal-recycling": {
    slug: "scrap-metal-recycling",
    name: "Scrap Metal Recycling",
    title: "Websites for scrap yards and metal recyclers.",
    seoTitle: "Scrap Yard & Metal Recycling Website Design | WebJesters",
    description:
      "Websites for scrap yards and metal recyclers: call-first layout, materials list and bulk-load quote forms with photo uploads. $499 build + $79/mo.",
    intro:
      "People searching for a scrap yard want three things: what you buy, where you are, and a phone number. A good recycling site answers all three in seconds on a phone, then makes it easy to send photos of a load for a quote. We build it that way and keep it running.",
    needs: [
      ["Call-first layout", "Hours, address, and a tap-to-call number sit at the top of every page — the way scrap customers actually use a site."],
      ["Accepted materials, clearly listed", "Ferrous and non-ferrous categories laid out so sellers know what to bring before they load the truck."],
      ["Bulk-load quotes with photo uploads", "A quote form that lets customers attach photos of their load, so you can respond with real numbers."],
      ["Local trust signals", "Family-owned history, Google reviews, and location details presented plainly to earn the first visit."],
    ],
    example: {
      name: "Scrapman's Metals",
      label: "Live client site",
      category: "Scrap metal recycling · Ashley, OH",
      url: process.env.REACT_APP_CLIENT_SCRAPMANS_URL || "https://scrapmanmetals.com/",
      domain: "scrapmanmetals.com",
      desktop: null,
      mobile: "/portfolio/scrapmans-metals-mobile.jpg",
      summary:
        "Family-owned scrap yard site with call-first CTAs, a full materials showcase, and a bulk-load quote form with photo uploads — built, hosted, and managed for them.",
      accent: "#ef4444",
    },
    faqs: [
      {
        q: "How much does a scrap yard website cost?",
        a: "$499 one-time to build, plus $79/month to host, maintain, and support it. A $99 deposit reserves your build slot. Month-to-month, cancel anytime.",
      },
      {
        q: "Can customers send photos of their scrap for a quote?",
        a: "Yes. The Scrapman's Metals site includes a bulk-load quote form with photo uploads, and the same approach is available on your build.",
      },
      {
        q: "Can I update hours and accepted materials myself?",
        a: "Yes. Hours, services, photos, and business info are editable any time through the Command Center portal, and changes go live automatically.",
      },
    ],
  },
};
